/* eslint-disable boundaries/element-types */
import { FilterProps } from 'components/table/enhancements/filters/filterTypes'
import {
  removeFilter,
  useClickOutside,
} from 'components/table/enhancements/filters/filterUtils'
import {
  FilterContainer,
  FilterHeaderButton,
  RelativeWrap,
  RemoveFilterButton,
  StyledCloseIcon,
  StyledInput,
} from 'features/assetDatabase'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

const StyledFilterContainer = styled(FilterContainer)`
  width: 250px;
  min-width: 250px;
`

const StyledInputWrapper = styled.div`
  width: 100%;
`

export const StringFilter = <TData,>({
  column,
  columnHeader,
  setActiveFilters,
  navigate,
  disableUrlFilters,
}: FilterProps<TData>) => {
  const filterContainerRef = useRef<HTMLDivElement>(null)
  const inputRef = useRef<HTMLInputElement>(null)
  const [isInputVisible, setInputVisible] = useState(true)
  const [currentFilterValue, setCurrentFilterValue] = useState<string>('')
  const columnFilterValue = column.getFilterValue() as string

  useEffect(() => {
    if (columnFilterValue && columnFilterValue !== currentFilterValue) {
      setCurrentFilterValue(columnFilterValue)
      setInputVisible(false)
    }
  }, [columnFilterValue, currentFilterValue])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    column.setFilterValue(value || undefined)
    setCurrentFilterValue(value)

    // Update URL parameters (only if URL filters are enabled)
    if (!disableUrlFilters) {
      if (value) {
        navigate({
          to: '.',
          search: (prev) => ({
            ...prev,
            [column.id]: value,
          }),
        })
      } else {
        removeFilter(column, setActiveFilters, navigate)
      }
    }
  }

  const handleOutsideClick = () => {
    if (!currentFilterValue) {
      removeFilter(column, setActiveFilters, navigate)
    } else {
      setInputVisible(false)
    }
  }

  useClickOutside(filterContainerRef, handleOutsideClick)

  useEffect(() => {
    if (isInputVisible && inputRef.current) {
      inputRef.current.focus()
    }
  }, [isInputVisible])

  return (
    <RelativeWrap>
      <FilterHeaderButton
        onClick={() => setInputVisible((visible) => !visible)}>
        {columnHeader}
        {currentFilterValue && (
          <RemoveFilterButton
            onClick={() => removeFilter(column, setActiveFilters, navigate)}>
            {currentFilterValue}
            <StyledCloseIcon />
          </RemoveFilterButton>
        )}
      </FilterHeaderButton>
      {isInputVisible && (
        <StyledFilterContainer
          ref={filterContainerRef}
          className={isInputVisible ? 'input-visible' : ''}>
          <StyledInputWrapper>
            <StyledInput
              ref={inputRef}
              value={currentFilterValue}
              onChange={handleInputChange}
              placeholder={`Filter ${columnHeader.toLowerCase()}...`}
            />
          </StyledInputWrapper>
        </StyledFilterContainer>
      )}
    </RelativeWrap>
  )
}
